"use strict";

import Select from './select';
import Css from './css';
import {parentUntilAttribute} from './traverse';
import Ajax from './ajax';
import Emitter from './globalEmitter';

export default {
    shippingOptions: null,
    optionsOnChangeAttribute: null,
    init: function(el){
        this.shippingOptions = el || Select.one('[data-shipping-options]');
            if(this.shippingOptions !== null){
                this.optionsOnChangeAttribute = this.shippingOptions.getAttribute('data-shipping-options-on-change') || null;
                var self = this;
                this.shippingOptions.addEventListener('click', function(e) {
                    self.clickListener(e);
                }, false);
            }
    },
    clickListener: function(e){
        var shippingMethodValueElement = parentUntilAttribute(e.target, 'data-shipping-method-value');
        if(shippingMethodValueElement !== null) {
            e.preventDefault();
            var shippingMethodValue = shippingMethodValueElement.getAttribute('data-shipping-method-value'),
                self = this;
            if (shippingMethodValue !== null) {
                Ajax('PUT', window.location.origin + '/api/v1/carts/shipping/method', {
                        "shipping_method": shippingMethodValue
                    },
                    function (response) {
                        var responseJson = JSON.parse(response);
                        if (responseJson.data.hasOwnProperty('shippingMethod')) {
                            if (responseJson.data.shippingMethod == shippingMethodValue) {
                                Emitter.emit('shipping-method-change', self.optionsOnChangeAttribute);
                                var shippingMethodOptionsWithSelectedClass = Select.all('.cart__shipping-options__list-item--selected', self.shippingOptions);
                                if (shippingMethodOptionsWithSelectedClass !== null) {
                                    if (shippingMethodOptionsWithSelectedClass.length) {
                                        for (var i = 0, len = shippingMethodOptionsWithSelectedClass.length; i < len; i++) {
                                            Css.removeClass(shippingMethodOptionsWithSelectedClass[i], 'cart__shipping-options__list-item--selected');
                                        }
                                    }
                                }
                                var shippingMethodOption = Select.one('[data-shipping-method-option="' + shippingMethodValue + '"]', self.shippingOptions);
                                if (shippingMethodOption !== null) {
                                    Css.addClass(shippingMethodOption, 'cart__shipping-options__list-item--selected');
                                }
                            }
                        }
                    }
                );
            }
        }
    },
    onClickCallback: function(){}
};
